import script from "./OpenOrders.vue?vue&type=script&setup=true&lang=js"
export * from "./OpenOrders.vue?vue&type=script&setup=true&lang=js"

import "./OpenOrders.vue?vue&type=style&index=0&id=7981d247&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7981d247"]])

export default __exports__